const AMPLITUDE_PLUGIN_TYPES = {
    ENRICHMENT: 'enrichment',
};

export default AMPLITUDE_PLUGIN_TYPES;
